import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { CuentaBancariaService } from '../../../services/CuentaBancariaService';

const CuentaBancariaForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [bancosOptions, setBancosOptions] = useState([]);

  // Load bancos options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const bancos = await CuentaBancariaService.obtenerBancos();
      if (isMounted && Array.isArray(bancos)) {
        setBancosOptions(bancos);
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await CuentaBancariaService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
      id_banco: values.id_banco ? Number(values.id_banco) : values.id_banco,
      cuenta_rfc: values.cuenta_rfc ? String(values.cuenta_rfc).trim().toUpperCase() : values.cuenta_rfc,
    };
    return await CuentaBancariaService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'cuenta',
      label: 'Clave',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. CTA-01',
      validators: [Validators.required('La clave de cuenta es obligatoria')],
    },
    {
      name: 'cuenta_no',
      label: 'No. de Cuenta',
      type: 'text',
      col: 8,
      required: true,
      placeholder: 'Ej. 012345678901234567',
      validators: [Validators.required('El número de cuenta es obligatorio')],
    },
    {
      name: 'cuenta_nombre',
      label: 'Descripción',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. Cuenta Operativa Principal',
      validators: [Validators.required('La descripción es obligatoria')],
    },
    {
      name: 'cuenta_ccont',
      label: 'Cuenta Contable (Ccont)',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. 1102-001-000',
      validators: [Validators.required('La cuenta contable es obligatoria')],
    },
    {
      name: 'cuenta_rfc',
      label: 'RFC',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. BMN930209927',
      validators: [
        Validators.required('El RFC es obligatorio'),
        Validators.rfc('El RFC no tiene un formato válido (12 o 13 caracteres)'),
      ],
    },
    {
      name: 'id_banco',
      label: 'Banco',
      type: 'select',
      col: 6,
      required: true,
      options: bancosOptions,
      placeholder: 'Seleccionar banco...',
      validators: [Validators.required('El banco es obligatorio')],
    },
  ], [bancosOptions]);

  return (
    <CatalogForm
      title="Cuenta Bancaria"
      subtitle="Administración de cuentas bancarias y contables"
      fields={fields}
      initialValues={{
        cuenta: '',
        cuenta_no: '',
        cuenta_nombre: '',
        cuenta_ccont: '',
        cuenta_rfc: '',
        id_banco: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CuentasBancarias"
    />
  );
};

export default CuentaBancariaForm;
